export default __webpack_public_path__ + "static/media/2-preview.528971bd.png";